<template>
    <div class="content-wapper">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/xwqyczfw/flwqdxalyfx' }">法律维权典型案例与分析</el-breadcrumb-item>
                    <el-breadcrumb-item>详情</el-breadcrumb-item>
                </el-breadcrumb>
                <!--
                <span>当前位置: &nbsp;&nbsp;</span>
                <span>小微企业成长服务 </span>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="toPage('/main/xwqyczfw/flwqdxalyfx')"> 法律维权典型案例与分析 </el-link>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="refresh" class="router"> 详情</el-link>
                -->
            </el-col>
        </el-row>

        <el-row class="content">
            <h1  style="font-family: 微软雅黑, 宋体">{{detail.title}}</h1>
            <el-row class="soure">
                <span style="padding-right: 130px;">发布时间：{{ parseTime(detail.updateTime, '{y}-{m}-{d}') }}</span><span style="padding-right: 130px;">访问量：{{browseCount}}</span><span>来源：{{fbDept}}</span>
            </el-row>
            <div v-html="detail.content" class="eidt-content"></div>
        </el-row>

    </div>
</template>

<script>
    import { getBrowseCount } from "@/api/basedata/records";
    import {getFlwqdxalyfxTzgg} from "@/api/xwqy/fvwqdxalyfxTzgg";
    export default {
        name: "detail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid:undefined,
                type:undefined,
                detail:{},
                browseCount:undefined,
                fbDept: '威海市市场监督管理局',
                ywViews:{
                    busRecid:undefined,
                    busTableName:'yw_jyjcfw_tzsb_tzgg',
                },
            }
        },
        created() {

            this.recid = this.$route.params && this.$route.params.recid;
            this.getDetail();
        },
        methods: {
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getDetail();
            },
            getDetail(){
                let recid = this.recid;
                getFlwqdxalyfxTzgg(recid).then(response =>{
                    this.detail = response.data;
                    this.getBrowseData();
                });
                // this.detail={
                //     title:'异议股东请求公司收购股份，退出公司',
                //     updateTime:'2021-10-13 10:17',
                //     deptname:'国家市场监督管理局',
                //     content:'<p style="text-align: left;">2002年2月，宋某、董某与其他3名股东共同出资成立某机械有限公司，其中宋某共出资6万元，占公司股权的12%，任公司财务负责人，董某出资26万元，占公司股权的52%，任公司董事长和法定代表人。2009年，宋某与董某产生矛盾，董某控制公司，与宋某解除合作关系。2013年，宋某以公司连续十余年未分红为由，向法院起诉，要求公司收购其股权。法院最终依据公司的资产评估值，判决公司以83万元的价格收购宋某的股份。</p>'
                //
                // };
                //this.getBrowseData();
            },
            getBrowseData(){
                this.ywViews.busRecid= this.recid;
                getBrowseCount(this.ywViews).then(response => {
                    this.browseCount=response;
                })
            }
        }
    }
</script>

<style scoped>
    .content-wapper{
        margin-top: 5px;
        padding: 10px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .content{
        border: 1px solid #cccccc;
        padding:20px 80px;
    }
    .soure{
        background-color:#f3f3f3;
        padding:10px;
        margin: 25px 0;
    }
    .eidt-content{
        text-align: left;
    }
</style>